import useEpisodeNewsletterTemplateQuery from '@queries/newsletter/useEpisodeNewsletterTemplateQuery.hook';
import EpisodeEditFormNewsletterForm from '@app/organisms/EpisodeEditForm/EpisodeEditFormNewsletter/EpisodeEditFormNewsletterForm';
import { useEpisodeBeingEdited } from '@app/organisms/EpisodeEditForm/EpisodeEditFormContext';

const EpisodeEditFormNewsletterEditor = () => {
    const episode = useEpisodeBeingEdited();
    const episodeNewsletterTemplateQuery = useEpisodeNewsletterTemplateQuery(episode.id);

    if (episodeNewsletterTemplateQuery.isLoading) {
        // TODO Handle loading state
        return 'LOADING';
    }

    if (episodeNewsletterTemplateQuery.error) {
        // TODO Handle error state
        return 'ERROR';
    }

    const { data: episodeNewsletterTemplate } = episodeNewsletterTemplateQuery;

    return <EpisodeEditFormNewsletterForm template={episodeNewsletterTemplate} />;
};

export default EpisodeEditFormNewsletterEditor;
